import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperBlockSlider() {

    const selector = ".block-slider__swiper";
    const swiperEls = document.querySelectorAll(selector);
    if (!swiperEls.length) return;

    swiperEls.forEach((el) => {
        const root = el.closest('.block-slider');
        if (!root) return;

        const autoplay = root.dataset.autoplay === 'true';
        const autoplayDelay = Number(root.dataset.autoplayDelay || root.dataset['autoplayDelay'] || 5000);
        const navigation = root.dataset.navigation === 'true';
        const pagination = root.dataset.pagination === 'true';
        const slidesPerView = Number(root.dataset.slidesPerView) || 1;
        const spaceBetween = Number(root.dataset.spaceBetween) || 20;

        const options = {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            speed: 700,
            slidesPerView,
            spaceBetween,
            watchSlidesProgress: true,
            preloadImages: true,
        };

        // Breakpoints para responsividad
        options.breakpoints = {
            0: {
                slidesPerView: Number(root.dataset.slidesPerViewPhone) || 1.3,
            },
            768: {
                slidesPerView: Number(root.dataset.slidesPerViewTablet) || 1.3,
            },
            992: {
                slidesPerView: Number(root.dataset.slidesPerView) || 1,
            }
        };

        if (navigation) {
            options.navigation = {
                nextEl: root.querySelector('.swiper-button-next'),
                prevEl: root.querySelector('.swiper-button-prev')
            };
        }

        if (pagination) {
            options.pagination = {
                el: root.querySelector('.swiper-pagination'),
                clickable: true,
            };
        }

        if (autoplay) {
            options.autoplay = { delay: autoplayDelay, disableOnInteraction: false, pauseOnMouseEnter: false };
        }

        // Create the instance
        new Swiper(el, options);
    });
}
